<app-page-shell [breadcrumb]="breadcrumb" width="wide">
  <header class="mx-auto max-w-4xl pt-16 text-center md:pt-24">
    <p class="eyebrow">{{ 'pages.arp.hero.eyebrow' | transloco }}</p>
    <h1 class="mt-4 font-display text-4xl font-bold leading-[1.05] text-ink md:text-6xl">
      {{ 'pages.arp.hero.titlePrefix' | transloco }}
      <em class="not-italic text-primary">{{ 'pages.arp.hero.titleAccent' | transloco }}</em>
    </h1>
    <p class="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
      {{ 'pages.arp.hero.descriptionPrefix' | transloco }}
      <strong class="font-semibold text-foreground">
        {{ 'pages.arp.hero.descriptionStrong' | transloco }}
      </strong>
      {{ 'pages.arp.hero.descriptionSuffix' | transloco }}
    </p>
  </header>

  <div class="mx-auto mt-16 max-w-5xl space-y-16">
    @for (section of sections; track section.titleKey) {
      <section>
        <h2 class="font-display text-xl font-bold text-foreground md:text-2xl">
          {{ section.titleKey | transloco }}
        </h2>
        <p class="mt-4 text-base leading-relaxed text-muted-foreground md:text-[17px]">
          {{ section.bodyKey | transloco }}
        </p>
      </section>
    }

    <aside class="relative overflow-hidden rounded-3xl bg-gradient-arp px-7 py-10 text-primary-foreground shadow-elevated md:px-12 md:py-12">
      <div
        aria-hidden="true"
        class="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary/20 blur-3xl"
      ></div>
      <div class="relative grid gap-6 md:grid-cols-[1fr_1.4fr] md:items-center md:gap-12">
        <p class="font-display text-4xl font-light leading-[0.95] md:text-5xl">
          {{ 'pages.arp.didYouKnow.titleLine1' | transloco }}
          <br />
          <span class="font-bold">{{ 'pages.arp.didYouKnow.titleLine2' | transloco }}</span>
        </p>
        <p class="text-base leading-relaxed text-primary-foreground/85 md:text-[17px]">
          {{ 'pages.arp.didYouKnow.bodyPrefix' | transloco }}
          <em class="italic text-primary-glow">{{ 'pages.arp.didYouKnow.productName' | transloco }}</em>
          {{ 'pages.arp.didYouKnow.bodySuffix' | transloco }}
        </p>
      </div>
    </aside>

    <section>
      <h2 class="font-display text-xl font-bold text-foreground md:text-2xl">
        {{ 'pages.arp.audience.title' | transloco }}
      </h2>
      <p class="mt-4 text-base leading-relaxed text-muted-foreground md:text-[17px]">
        {{ 'pages.arp.audience.body' | transloco }}
      </p>
    </section>

    <section>
      <h2 class="font-display text-xl font-bold text-foreground md:text-2xl">
        {{ 'pages.arp.access.title' | transloco }}
      </h2>

      <ol class="mt-6 grid gap-6 rounded-2xl border border-primary/30 bg-card p-6 md:grid-cols-3 md:p-8">
        @for (category of accessCategories; track category.titleKey; let index = $index) {
          <li class="flex flex-col">
            <span class="font-display text-4xl font-bold leading-none text-primary md:text-5xl">
              {{ index + 1 }}.
            </span>
            <h3 class="mt-4 font-display text-base font-semibold leading-snug text-foreground">
              {{ category.titleKey | transloco }}
            </h3>
            <p class="mt-3 text-sm leading-relaxed text-muted-foreground">
              {{ category.descriptionKey | transloco }}
            </p>
          </li>
        }
      </ol>
    </section>

    <section class="relative overflow-hidden rounded-3xl bg-gradient-arp px-7 py-10 text-primary-foreground shadow-elevated md:px-12 md:py-12">
      <div
        aria-hidden="true"
        class="pointer-events-none absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-primary/20 blur-3xl"
      ></div>
      <div class="relative">
        <h2 class="font-display text-xl font-bold text-primary-foreground md:text-2xl">
          {{ 'pages.arp.learnMore.title' | transloco }}
        </h2>
        <p class="mt-4 text-base leading-relaxed text-primary-foreground/85 md:text-[17px]">
          {{ 'pages.arp.learnMore.bodyPrefix' | transloco }}
          <a
            [href]="arpUrl"
            target="_blank"
            rel="noreferrer"
            class="font-semibold text-primary-glow underline-offset-4 hover:underline"
          >
            {{ 'pages.arp.learnMore.linkLabel' | transloco }}
          </a>
          {{ 'pages.arp.learnMore.bodySuffix' | transloco }}
        </p>
      </div>
    </section>

    <section class="text-center">
      <h2 class="font-display text-xl font-bold leading-tight text-foreground md:text-2xl">
        {{ 'pages.arp.cta.titlePrefix' | transloco }}
        <span class="italic text-primary">{{ 'pages.arp.cta.titleAccent' | transloco }}</span>
      </h2>
      <div class="mt-6">
        <a
          [href]="arpUrl"
          target="_blank"
          rel="noreferrer"
          class="inline-flex items-center justify-center rounded-full border border-primary/40 bg-card px-6 py-2.5 text-sm font-semibold text-primary shadow-sm transition hover:bg-primary hover:text-primary-foreground"
        >
          {{ 'pages.arp.cta.linkLabel' | transloco }}
        </a>
      </div>
    </section>

    <section id="dicionario" class="border-t border-border pt-12">
      <p class="eyebrow">{{ 'pages.arp.dataDictionary.eyebrow' | transloco }}</p>
      <h2 class="mt-2 font-display text-xl font-bold text-foreground md:text-2xl">
        {{ 'pages.arp.dataDictionary.title' | transloco }}
      </h2>
      <p class="mt-4 text-base leading-relaxed text-muted-foreground md:text-[17px]">
        {{ 'pages.arp.dataDictionary.body' | transloco }}
      </p>
      <div class="mt-6">
        <a
          [href]="dataDictionaryHref"
          class="inline-flex items-center justify-center rounded-full border border-primary/40 bg-card px-6 py-2.5 text-sm font-semibold text-primary shadow-sm transition hover:bg-primary hover:text-primary-foreground"
        >
          {{ 'pages.arp.dataDictionary.cta' | transloco }}
        </a>
      </div>
    </section>
  </div>
</app-page-shell>
